/* The collection's filters. The port's own script (the review file showed the pills unwired): a pill shows the products it
   names and hides the rest, All shows every one, and the count follows. Copied into assets by tools/build-assets.mjs. */
(function () {
  [].forEach.call(document.querySelectorAll('[data-tools]'), function (tools) {
    var grid = document.getElementById(tools.getAttribute('data-tools'));
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('[data-product]'));
    var pills = [].slice.call(tools.querySelectorAll('[data-tool]'));
    var count = tools.querySelector('[data-tools-n]');
    var tpl = count ? count.getAttribute('data-tpl') || '[n]' : '[n]';
    function pick(p) {
      var ids = (p.getAttribute('data-ids') || '').split(',').filter(Boolean);
      var n = 0;
      cards.forEach(function (c) {
        var on = !ids.length || ids.indexOf(c.getAttribute('data-product')) > -1;
        c.hidden = !on;
        if (on) n++;
      });
      pills.forEach(function (x) { x.classList.toggle('is-on', x === p); x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
      if (count) count.textContent = tpl.replace('[n]', n);
    }
    pills.forEach(function (p) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(p); } });
    });
  });
})();
